<template>
    <ul class="pagination justify-content-center">
        <li
            v-for="control in controls"
            :class=control.classes
        >
            <a class="page-link" @click="update(control.id)">
                {{control.id}}
            </a>
        </li>
    </ul>
</template>
<script>
    export default {
        props: [
            'currentQuestion',
            'range',
            'max'
        ],
        data() {
            return {
                'controls': [],
                'min': 1
            }
        },
        methods: {
            setControls: function () {
                this.controls = [];
                let i = 0 - this.range;
                let current = this.currentQuestion+1;
                for (i; i <= this.range; i++) {
                    if ((current + i) >= this.min && (current + i <= this.max)) {
                        let classes = 'page-item';
                        if(i === 0){
                            classes += ' active';
                        }
                        this.controls.push({'id':current + i,'classes': classes});
                    }
                }
            },
            update: function (id) {
                this.$emit('setCurrentQuestion', id);
                this.setControls();
            }
        },
        created: function () {
            this.setControls();
        },
        watch:{
            'currentQuestion': function(){
                this.setControls();
            }
        }
    }
</script>
